import { render, staticRenderFns } from "./AddStep5.vue?vue&type=template&id=1c015638&scoped=true&"
import script from "./AddStep5.vue?vue&type=script&lang=js&"
export * from "./AddStep5.vue?vue&type=script&lang=js&"
import style0 from "./AddStep5.vue?vue&type=style&index=0&id=1c015638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c015638",
  null
  
)

export default component.exports